export default (state, action) => {
    switch (action.type) {
        case 'GET_USERS':
            return {
                ...state,
                loading: false,
                users: action.payload,
                next: action.next,
                previous: action.previous,
                count: action.count
            }

        case 'VIEW_USER_PARENT':
            return {
                ...state,
                loading: false,
                parent: action.payload
            }

        case 'VIEW_USER_DATA':
            return {
                ...state,
                loading: false,
                editUser: action.payload
            }

        case 'SORT_TABLE':
            return {
                ...state,
                loading: false,
                users: action.payload,
                sortName: action.sortName,
                sortOrder: action.sortOrder,
                next: action.next,
                previous: action.previous,
                count: action.count
            }

        case 'CHANGE_TABLE_NUM_ROWS':
            return {
                ...state,
                loading: false,
                users: action.payload,
                next: action.next,
                previous: action.previous,
                count: action.count,
                page: action.page,
                rowsPerPage: action.rowsPerPage
            }

        case 'SET_TABLE_PAGE_NO':
            return {
                ...state,
                loading: false,
                users: action.payload,
                next: action.next,
                previous: action.previous,
                count: action.count,
                page: action.page
            }

        case 'QUERY_TABLE_DATA':
            return {
                ...state,
                query: action.query,
                users: action.payload,
                next: action.next,
                previous: action.previous,
                count: action.count
            }

        case 'ADD_USER':
            return {
                ...state,
                loading: false,
                users: [...state.users , action.payload],
                success: action.success,
                error: action.error
            }

        case 'DELETE_USER':
            return {
                ...state,
                users: state.users.filter(user => user[0] !== action.payload)
            }

        case 'UPDATE_USER':
            return {
                ...state,
                loading: false,
                users: [...state.users , action.payload],
            }

        case 'USER_ERROR':
            return {
                ...state,
                error: action.payload
            }

        case 'CLEAR_USER_ERROR':
            return {
                ...state,
                error: []
            }

        case 'CLEAR_USER_STATE':
            return {
                ...state,
                parent: [],
                users: []
            }

        default:
            return state;
    }
}